import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import AuthorAvatarInfo from '../../../../../common/src/components/pc/author-avatar-info/author-avatar-info.vue';
import moment from 'moment';
import { listApi } from '../../../../../api';
import { workbenchApi } from "../../../../../api";
let tipsItem = class tipsItem extends Vue {
    constructor() {
        super(...arguments);
        this.messageType = {
            101: '待您处理',
            102: '已完成',
            103: '出现异常',
            104: '已作废',
            105: '已删除',
            106: '抄送给您',
            // 107: '已完成',
            1: '已启动',
            2: '已结束',
            3: '被取消',
            4: '已激活',
            11: '即将被激活',
            12: '已完成',
            13: '已完成',
            14: '已取消',
            16: '已审批',
            17: '被驳回',
            23: '已超时，请及时处理',
            62: '请在“云枢后台-组织机构-工作交接”中交接他的任务',
        };
        this.messageTypeI18n = {
            101: ' needs you to deal',
            102: ' has been completed',
            103: ' has a defect',
            104: ' has been Canceled',
            105: ' has been deleted',
            106: 'sends to you',
            // 107: '已完成',
            1: ' has started',
            2: ' has ended',
            3: ' has been canceled',
            4: ' activated',
            11: ' will be activated',
            12: ' has been completed',
            13: ' has been completed',
            14: ' has been canceled',
            16: ' has been aproved',
            17: ' has been rejected',
            23: ' has timed out, please deal with it in time',
            62: ' please hand over his duties in "Yunshu Manage-Organization-WorkTransfer"',
        };
        this.stateMap = {
            PROCESSING: '进行中', COMPLETED: '已完成', CANCELED: '作废', EXCEPTION: '异常'
        };
        this.stateMapI18n = {
            PROCESSING: 'processing', COMPLETED: 'completed', CANCELED: 'canceled', EXCEPTION: 'exception'
        };
        this.isDingtalk = /DingTalk/.test(navigator.userAgent);
    }
    /**
     * 高亮
     */
    queryTitleLight(titleInfo) {
        if (!titleInfo)
            return;
        const strReturn = titleInfo.replace(new RegExp(this.wd, "g"), `<span class="highlights">${this.wd}</span>`);
        return strReturn;
    }
    get isChinese() {
        return !(this.$i18n.locale && this.$i18n.locale === "en");
    }
    get bizParams() {
        let bizparam = this.item.bizParams && JSON.parse(this.item.bizParams) || {};
        if (bizparam.originatorName) {
        }
        return bizparam;
    }
    get user() {
        let str = sessionStorage.getItem('user') || '';
        return str && JSON.parse(str) || {};
    }
    formatTime(time) {
        let now = new Date();
        let diffTime = now.getTime() - time;
        if (diffTime <= 5 * 60 * 1000) {
            return '刚刚';
        }
        if (diffTime <= 10 * 60 * 1000) {
            return '5分钟前';
        }
        if (diffTime <= 30 * 60 * 1000) {
            return '10分钟前';
        }
        return moment(time).format('YYYY-MM-DD HH:mm');
    }
    getTimeOutTime(time) {
        console.log(time);
        if (time.includes('天')) {
            const num = parseInt(time.slice(0, -1));
            return num + (num > 1 ? ' days' : ' day');
        }
        else if (time.includes('时')) {
            let num = 0;
            if (time.includes('小')) {
                num = parseInt(time.slice(0, -2));
            }
            else {
                num = parseInt(time.slice(0, -1));
            }
            return num + (num > 1 ? ' hours' : ' hour');
        }
        else if (time.includes('分')) {
            let num = 0;
            if (time.includes('钟')) {
                num = parseInt(time.slice(0, -2));
            }
            else {
                num = parseInt(time.slice(0, -1));
            }
            return num + (num > 1 ? ' minutes' : ' minute');
        }
        else if (time.includes('秒')) {
            const num = parseInt(time.slice(0, -1));
            return num + (num > 1 ? ' secss' : ' second');
        }
    }
    getWhoseWork(content) {
        const index = content.indexOf(this.bizParams.success);
        return content.slice(13, index - 1);
    }
    getComment(content) {
        const index = content.indexOf("交接意见");
        return content.slice(index + 5);
    }
    getComment2(content) {
        if (!(typeof content === "object")) {
            content = JSON.parse(content);
        }
        const dataItem = content.dataItems;
        return dataItem.filter((i) => {
            return i.key === "交接意见";
        })[0].value;
    }
    getWho(content) {
        const startIndex1 = content.indexOf("【");
        const endIndex1 = content.indexOf("】");
        return content.slice(startIndex1 + 1, endIndex1);
    }
    getStartTime(content) {
        const startIndex1 = content.indexOf("【");
        const startIndex2 = content.indexOf("【", startIndex1 + 1);
        const endIndex1 = content.indexOf("】");
        const endIndex2 = content.indexOf("】", endIndex1 + 1);
        return content.slice(startIndex2 + 1, endIndex2);
    }
    getEndTime(content) {
        const startIndex1 = content.indexOf("【");
        const startIndex2 = content.indexOf("【", startIndex1 + 1);
        const startIndex3 = content.indexOf("【", startIndex2 + 1);
        const endIndex1 = content.indexOf("】");
        const endIndex2 = content.indexOf("】", endIndex1 + 1);
        const endIndex3 = content.indexOf("】", endIndex2 + 1);
        return content.slice(startIndex3 + 1, endIndex3);
    }
    gotoInfo() {
        if (this.item.messageType === 62) {
            if (this.bizParams.userNameList.length > 0) {
                //跳转后台工作交接查询界面
                window.open(`/admin/#/organization/workHandover?userName=${this.bizParams.userNameList[0]}`);
            }
        }
        else {
            if (this.bizParams.workflowInstanceId) {
                window.open(`/form/detail?workitemType=${this.bizParams.workItemType}&workitemId=${this.bizParams.WorkItemId}&workflowInstanceId=${this.bizParams.workflowInstanceId}`);
            }
            else {
                this.open(this.bizParams.objectId, this.bizParams.schemaCode);
            }
        }
        this.updateReadState(this.item.id);
    }
    open(bizObjectId, schemaCode) {
        const params = {
            bizObjectId,
            schemaCode
        };
        listApi.getFormUrl(params).then((res) => {
            if (this.isDingtalk) {
                res += '&T=' + localStorage.getItem('token');
            }
            window.open(res);
        });
    }
    updateReadState(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = yield workbenchApi.updateReadState({
                messageIdList: [id]
            });
        });
    }
    getHtml(text) {
        if (!text) {
            return;
        }
        return text.replace(/<span.+<\/span>/g, '');
    }
};
tslib_1.__decorate([
    Prop()
], tipsItem.prototype, "item", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], tipsItem.prototype, "isShowInfo", void 0);
tslib_1.__decorate([
    Prop({
        default: '250px'
    })
], tipsItem.prototype, "infosWidth", void 0);
tslib_1.__decorate([
    Prop({
        default: ''
    })
], tipsItem.prototype, "type", void 0);
tslib_1.__decorate([
    Prop({ default: '' })
], tipsItem.prototype, "wd", void 0);
tipsItem = tslib_1.__decorate([
    Component({
        name: 'tipsItem',
        components: {
            AuthorAvatarInfo
        }
    })
], tipsItem);
export default tipsItem;
